export default "__VITE_ASSET__Dm2_Y4sX__"